// extracted by mini-css-extract-plugin
export default {"phoneInput":"index_phoneInput__0GjMI","select":"index_select__8vxjC","icon":"index_icon__JqXkD","error":"index_error__vyATS"};